import React from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/summary/QuizSummary.scss';

const QuizSummary = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <div className="csw-quiz-summary">
      <div className="csw-quiz-summary-detail" role="heading" aria-level="1">
        {i18n.t("QUIZ_SUMMARY_YOU_ANSWERED")}
      </div>
      <div className="h2 h-trim" role="heading" aria-level="2">
        {i18n.t("QUIZ_SUMMARY_CORRECT_OUT_OF_TOTAL", {
          countCorrect: summary["countCorrect"],
          countTotal: summary["countTotal"],
        })}
      </div>
      <div className="csw-quiz-summary-detail">{i18n.t("QUIZ_SUMMARY_QUESTIONS_CORRECTLY")}</div>
    </div>
  );
};

QuizSummary.propTypes /* remove-proptypes */ = {
  summary: PropTypes.object.isRequired,
};

export default QuizSummary;
